import { render } from "./LoadingTables.vue?vue&type=template&id=5cb30e58"
import script from "./LoadingTables.vue?vue&type=script&lang=js"
export * from "./LoadingTables.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__